var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationSocialSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 66H48v-9c0-.1 0-3.4 2.3-5.7L60.6 41H62c2.2 0 4 1.8 4 4v1.4l-7.3 7.3-1.4-1.4 6.7-6.7V45c0-1.1-.9-2-2-2h-.6l-9.7 9.7C50 54.4 50 57 50 57v7h9v-1c0-.1 0-2.4 2.3-4.7l7-7C70 49.6 70 48.1 70 48V32c0-1.1-.9-2-2-2s-2 .9-2 2v8h-2v-8c0-2.2 1.8-4 4-4s4 1.8 4 4v16c0 .1 0 2.4-2.3 4.7l-7 7C61.1 61.4 61 62.9 61 63v3z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 72h-2v-6H48v6h-2v-6c0-1.1.9-2 2-2h13c1.1 0 2 .9 2 2v6zM32 66H19v-3c0-.1-.1-1.6-1.7-3.3l-7-7C8 50.4 8 48.1 8 48V32c0-2.2 1.8-4 4-4s4 1.8 4 4v8h-2v-8c0-1.1-.9-2-2-2s-2 .9-2 2v16c0 .1.1 1.6 1.7 3.3l7 7C21 60.6 21 62.9 21 63v1h9v-7s0-2.6-1.7-4.3L18.6 43H18c-1.1 0-2 .9-2 2v.6l6.7 6.7-1.4 1.4-7.3-7.3V45c0-2.2 1.8-4 4-4h1.4l10.3 10.3C32 53.6 32 56.9 32 57v9z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 72h-2v-6H19v6h-2v-6c0-1.1.9-2 2-2h13c1.1 0 2 .9 2 2v6zM62 30h-2c0-11-9-20-20-20s-20 9-20 20h-2c0-12.1 9.9-22 22-22s22 9.9 22 22zM18 32h2v2h-2zM18 36h2v2h-2zM60 32h2v2h-2zM60 36h2v2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 33c-3.8 0-6-4.1-6-8 0-3.6 1-6 6-6s6 2.4 6 6c0 3.9-2.2 8-6 8zm0-12c-3.4 0-4 1-4 4 0 2.9 1.5 6 4 6s4-3.1 4-6c0-3-.6-4-4-4z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 41H32c-1.6 0-3-1.8-3-4v-2c0-.4.2-.7.5-.9l7-4 1 1.7-6.5 3.8V37c0 1.2.7 2 1 2h16c.3 0 1-.8 1-2v-1.4l-6.5-3.7 1-1.7 7 4c.3.2.5.5.5.9v2c0 2.1-1.4 3.9-3 3.9z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationSocialSecurity;